import { createSelector } from '@ngrx/store';

import { paxRootSelector } from '@pax/store/selectors/pax-root.selector';
import { PaxState } from '@pax/store/state/pax.state';
import { guestListUIAdapter } from '@pax/store/reducers/ui/guest-list-ui.reducer';

const { selectAll } = guestListUIAdapter.getSelectors();

const getGuestListUIState = createSelector(paxRootSelector, (state: PaxState) => state && state.ui ?
  state.ui.guestListUI : []);

export const selectGuestListUI = createSelector(getGuestListUIState, selectAll);
